import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './ReportModal.css';

const ReportModal = ({ onClose, tool, theme, header, description }) => {
  const [reportText, setReportText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID?.trim();
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID?.trim();
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY?.trim();
    setErrorMessage('');

    if (!serviceId || !templateId || !publicKey) {
      setErrorMessage('Submissions are temporarily unavailable. Your message has not been sent. Please try again later.');
      return;
    }

    const templateParams = {
      tool_name: tool.name,
      report_text: reportText,
    };

    setIsSubmitting(true);
    try {
      await emailjs.send(serviceId, templateId, templateParams, publicKey);
      onClose();
    } catch {
      setErrorMessage('Your message could not be sent. It has been kept here so you can try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
      <div className="modal-overlay">
        <div className={`modal-content ${theme}`}>
          <h2>{header}</h2>
          <form onSubmit={handleSubmit} aria-busy={isSubmitting}>
            <p>{description}</p>
            <textarea
                value={reportText}
                onChange={(e) => setReportText(e.target.value)}
                required
                rows="5"
                aria-label={description}
            />
            {errorMessage && <p role="alert">{errorMessage}</p>}
            <div className="modal-actions">
              <button type="button" onClick={onClose}>Cancel</button>
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>
  );
}

export default ReportModal;
